const AuthBackgroundShape = () => {
  return (
    <svg
      className='h-screen w-screen opacity-20'
      viewBox='0 0 1200 800'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='gradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='currentColor' stopOpacity='0.3' />
          <stop offset='100%' stopColor='currentColor' stopOpacity='0.1' />
        </linearGradient>
        <linearGradient id='accent-gradient' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0.5' />
          <stop offset='100%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0.2' />
        </linearGradient>
        <linearGradient id='accent-gradient-2' x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0.4' />
          <stop offset='100%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0.15' />
        </linearGradient>
        <radialGradient id='radial-accent' cx='50%' cy='50%'>
          <stop offset='0%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0.6' />
          <stop offset='100%' stopColor='oklch(0.52 0.21 284)' stopOpacity='0' />
        </radialGradient>
      </defs>
      
      {/* Abstract blob shapes */}
      <path
        d='M 100 150 Q 200 50 350 100 T 500 200 Q 400 300 250 250 T 100 150 Z'
        fill='url(#accent-gradient)'
        opacity='0.8'
      />
      <path
        d='M 800 100 Q 950 50 1100 150 T 1150 350 Q 1050 400 900 350 T 800 100 Z'
        fill='url(#accent-gradient-2)'
        opacity='0.7'
      />
      
      {/* Circles with accent color */}
      <circle cx='200' cy='200' r='300' fill='url(#accent-gradient)' />
      <circle cx='1000' cy='600' r='400' fill='url(#accent-gradient-2)' />
      <circle cx='600' cy='400' r='200' fill='url(#radial-accent)' />
      
      {/* Additional abstract shapes */}
      <ellipse cx='150' cy='600' rx='250' ry='180' fill='url(#accent-gradient)' opacity='0.6' transform='rotate(-25 150 600)' />
      <path
        d='M 400 650 Q 500 550 600 600 T 700 700 Q 600 750 500 700 T 400 650 Z'
        fill='url(#gradient)'
        opacity='0.5'
      />
      
      {/* Geometric shapes */}
      <polygon
        points='900,200 1100,150 1150,300 950,350'
        fill='url(#accent-gradient-2)'
        opacity='0.6'
      />
      <rect
        x='50'
        y='450'
        width='200'
        height='200'
        rx='40'
        fill='url(#accent-gradient)'
        opacity='0.5'
        transform='rotate(45 150 550)'
      />
    </svg>
  )
}

export default AuthBackgroundShape

